/**
 * <av-sticky-atc> — mobile sticky Add to Bag bar for the product page.
 * Shows once the real price/buy-buttons area scrolls out of view above the
 * viewport, and mirrors price/availability from Dawn's native
 * `variant-change` pub/sub event instead of reformatting money in JS.
 */
if (!customElements.get('av-sticky-atc')) {
  class AvocadoStickyAtc extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(min-width: 750px)').matches) return;

      this.sectionId = this.dataset.sectionId;
      this.priceEl = this.querySelector('[data-av-sticky-price]');
      this.buttonEl = this.querySelector('[data-av-sticky-button]');

      const observeTarget = document.getElementById(this.dataset.observe);
      if (observeTarget) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.hidden = entry.isIntersecting;
            });
          },
          { rootMargin: '0px 0px 0px 0px' }
        );
        this.observer.observe(observeTarget);
      }

      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== this.sectionId) return;

        const newPrice = event.data.html.getElementById(`price-${this.sectionId}`);
        if (newPrice && this.priceEl) {
          this.priceEl.innerHTML = newPrice.innerHTML;
        }

        const sourceButton = event.data.html.getElementById(this.dataset.sourceButton);
        if (sourceButton && this.buttonEl) {
          this.buttonEl.disabled = sourceButton.hasAttribute('disabled');
          const sourceLabel = sourceButton.querySelector('span:first-child');
          const ownLabel = this.buttonEl.querySelector('span:first-child');
          if (sourceLabel && ownLabel) {
            ownLabel.textContent = sourceLabel.textContent;
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.unsubscribe) this.unsubscribe();
    }
  }

  customElements.define('av-sticky-atc', AvocadoStickyAtc);
}
